import React from 'react';
import HomeParallax from "components/homeParallax/HomeParallax";
import CookieModal from "components/cookieModal/CookieModal";
import Loader from "components/loader/Loader";
import LandscapeWarning from "components/landscapeWarning/LandscapeWarning";
import FocusDetector from "utils/FocusDetector";

const Home = (props) => {

    return (
        <>
            <CookieModal/>
            <Loader/>
            <HomeParallax/>
            <LandscapeWarning/>
            <FocusDetector/>
        </>
    )
};

export default Home